import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import { useState } from "react";
import blogs from "../blogs";
import HamburgerMenu from "../HamburgerMenu";

export default function BlogPost() {
  const { slug } = useParams();
  const [menuOpen, setMenuOpen] = useState(false);

  function linkify(text) {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    return text.split(urlRegex).map((part, index) => {
      if (part.match(urlRegex)) {
        return (
          <a
            key={index}
            href={part}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-400 underline"
          >
            {part}
          </a>
        );
      } else {
        return part;
      }
    });
  }

  const blogPost = blogs.find((b) => b.slug === slug);

  if (!blogPost) {
    return <p>Post not found.</p>;
  }

  const toggleMenu = (forceValue) => {
    if (typeof forceValue === "boolean") {
      setMenuOpen(forceValue);
    } else {
      setMenuOpen((prev) => !prev);
    }
  };

  return (
    <>
      <Helmet>
        <title>{blogPost.title} | What Grade Will It Get</title>
        <meta name="description" content={blogPost.description} />
        <meta name="keywords" content={blogPost.keywords.join(", ")} />
      </Helmet>

      <div className="min-h-screen flex flex-col text-white bg-black relative">
        <div className="absolute top-4 right-4 z-50">
          <HamburgerMenu menuOpen={menuOpen} toggleMenu={toggleMenu} />
        </div>

        <div className="max-w-3xl mx-auto p-4 mt-12">
          <h1 className="text-4xl font-bold mb-4">{blogPost.displayTitle}</h1>
          <p className="text-gray-400 text-sm mb-6">{blogPost.date}</p>

          {blogPost.content.map((block, idx) => {
            if (block.type === "heading") {
              return (
                <h2 key={idx} className="text-2xl font-semibold mt-8 mb-4">
                  {block.text}
                </h2>
              );
            }

            if (block.type === "paragraph") {
              return (
                <p key={idx} className="mb-4 leading-relaxed text-lg">
                  {linkify(block.text)}
                </p>
              );
            }

            if (block.type === "list") {
              return (
                <ul key={idx} className="list-disc pl-5 mb-4">
                  {block.items.map((item, i) => (
                    <li key={i} className="mb-2">
                      {linkify(item)}
                    </li>
                  ))}
                </ul>
              );
            }

            return null;
          })}
        </div>
      </div>
    </>
  );
}
